import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

// TODO: current 16px variation uses multiple `d` tags
const draw24px =
  'M22,17.31,18.78,20.5a.75.75,0,0,1-1.06,0l-3.19-3.19A.75.75,0,0,1,15.06,16H17.5V4A.75.75,0,0,1,19,4V16h2.44A.75.75,0,0,1,22,17.31Zm-11.8-6H12L8.88,1.76H6.55L3.64,11.29H5.37l.72-2.51h3.3ZM7.71,3,9,7.41H6.47Zm.7,12a2.49,2.49,0,0,0-1.88.75V12.09H4.84v9.54H6.16L6.31,21a2.55,2.55,0,0,0,1.89.79,2.65,2.65,0,0,0,1.5-.45,3,3,0,0,0,1.1-1.23,3.73,3.73,0,0,0,.36-1.65v-.11a4.48,4.48,0,0,0-.34-1.82,2.79,2.79,0,0,0-1-1.19A2.46,2.46,0,0,0,8.41,14.93Zm1.06,3.48A2.63,2.63,0,0,1,9.06,20a1.35,1.35,0,0,1-1.14.55,1.84,1.84,0,0,1-1.39-.6V17a1.75,1.75,0,0,1,.67-.57,1.81,1.81,0,0,1,.87-.21c.93,0,1.4.7,1.4,2.1Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationVerticalStackedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(
  generateRenderedIcon(icons, 'textOrientationVerticalStacked'),
) as IconWithRender;

TextOrientationVerticalStackedIcon.displayName =
  'TextOrientationVerticalStackedIcon';
TextOrientationVerticalStackedIcon.propTypes = Icon.propTypes;
TextOrientationVerticalStackedIcon.renderIcon = (props) => (
  <TextOrientationVerticalStackedIcon {...props} />
);
export default TextOrientationVerticalStackedIcon;
